<template>
    <main id="content" class="sma-about-content">
        <div class="container">
            <div class="link-page">
                <div class="breacrump">
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/" class="link-home">
                            <span itemprop="title">{{ $t("app.Home") }}</span>
                        </router-link>
                        <span class="slashes-link">/</span>
                    </div>
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <router-link to="/blog" itemprop="url">
                            <span itemprop="title">{{ $t("app.Blog") }}</span>
                        </router-link>
                        <span class="slashes-link">/</span>
                    </div>
                    <div
                        class="item-breacrump"
                        itemscope
                        itemtype="http://data-vocabulary.org/Breadcrumb"
                    >
                        <a @click.prevent itemprop="url">
                            <span itemprop="title">{{ post.title }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="main-single">
                <div class="left-single">
                    <div class="feature-single">
                        <img :src="post.image" alt />
                    </div>
                    <h2 class="title-single font-balo">
                        {{ post.title }}
                    </h2>
                    <div class="time-post font-balo">
                        {{ formatDate(post.date) }}
                    </div>
                    <div class="description-single" v-html="post.content"></div>
                    <div class="author-post font-bai" v-if="post.author_name">
                        <img
                            v-if="post.author_avatar"
                            :src="post.author_avatar"
                            alt
                        />{{ post.author_name }}
                    </div>
                    <div class="share-social">
                        <h4 class="title-share-post font-balo">
                            {{ $t("app.Share this story") }}
                        </h4>
                        <ShareNetwork
                            network="facebook"
                            :url="url"
                            :title="post.title"
                            :description="post.content"
                            class="icon-share share-facebook"
                        >
                            <i class="fa fa-facebook" aria-hidden="true"></i>
                        </ShareNetwork>
                        <ShareNetwork
                            network="twitter"
                            :url="url"
                            :title="post.title"
                            class="icon-share share-twitter"
                        >
                            <i class="fa fa-twitter" aria-hidden="true"></i>
                        </ShareNetwork>
                        <!-- <a class="icon-share share-youtube">
                            <i
                                class="fa fa-youtube-play"
                                aria-hidden="true"
                            ></i>
                        </a>
                        <a class="icon-share share-instagram" href="#">
                            <i class="fa fa-instagram" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="right-single">
                    <div
                        class="most-read"
                        v-if="post.most_posts && post.most_posts.length > 0"
                    >
                        <div class="title-most-read">
                            <h3 class="font-balo">{{ $t("app.Most read") }}</h3>
                        </div>
                        <div class="list-post-most">
                            <div
                                class="it-post-most"
                                v-for="(item, index) in post.most_posts"
                                :key="index"
                            >
                                <div class="feature-post">
                                    <router-link :to="`/blog/${item.id}`">
                                        <img
                                            v-if="item.image"
                                            :src="item.image"
                                            alt
                                        />
                                        <img
                                            v-if="!item.image"
                                            src="../assets/images/blog3.jpg"
                                            alt
                                        />
                                    </router-link>
                                </div>
                                <div class="description-post">
                                    <h3>
                                        <router-link :to="`/blog/${item.id}`">{{
                                            item.title
                                        }}</router-link>
                                    </h3>
                                    <div class="time-post">
                                        {{ formatDate(item.date) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
            <RelatedPosts
                :posts="post.most_posts"
                v-if="post.most_posts && post.most_posts.length > 0"
            />
        </div>
    </main>
</template>

<script>
import RelatedPosts from "@/components/RelatedPosts";
import { mapActions, mapState } from "vuex";
import { get } from "lodash";
import { setDescriptionPage } from "@/helper/helper";
import moment from "moment";
export default {
    name: "ArticlePage",
    data() {
        return {
            location: location,
            url: `${location.origin}${location.pathname}`
        };
    },
    components: {
        RelatedPosts
    },
    mounted() {
        const { params } = this.$route;
        this.getPost(params.id).then(() => {
            setDescriptionPage(get(this.post, "meta_description"));
        });
    },
    computed: {
        ...mapState({
            post: state => get(state, "blogs.post", {})
        })
    },
    methods: {
        ...mapActions("blogs", ["getPost"]),
        formatDate: function(date) {
            return moment(date, "DD.MM.YY").format("DD.MM.YY");
        }
    },
    watch: {
        $route(to) {
            const { params } = to;
            this.getPost(params.id).then(() => {
                setDescriptionPage(get(this.post, "meta_description"));
            });
        }
    }
};
</script>
